import type { VimeoReference } from './VimeoVideo.types';

/**
 * Pull the video id and unlisted-video privacy hash out of a Vimeo share or player URL.
 * Handles `vimeo.com/{id}` (optionally `/{privacyHash}`) and `player.vimeo.com/video/{id}?h=...`;
 * any other query params (old embed flags) are ignored. Returns null for anything without a numeric id.
 */
export const parseVimeoUrl = (videoUrl: string): VimeoReference | null => {
  try {
    const url = new URL(videoUrl);
    const segments = url.pathname.split('/').filter(Boolean);
    const videoId = segments.find(segment => /^\d+$/.test(segment));
    if (!videoId) {
      return null;
    }
    // Privacy hash is either the path segment after the id (vimeo.com/{id}/{hash}) or the `h` query param.
    const privacyHash = segments[segments.indexOf(videoId) + 1] ?? url.searchParams.get('h') ?? undefined;
    return { videoId, privacyHash };
  } catch {
    return null;
  }
};
